import React, { forwardRef } from "react";

import { MachineList, ObjectListHeader, OtherObjectList } from "@/sx-layout/components/plotmap/components/objectList";
import { useObjectList } from "@/sx-layout/components/plotmap/components/objectList/hooks/useObjectList";

type Props = {
  isOpen: boolean;
  onToggleList: () => void;
  onZoomMachine: (_: number) => void;
  onZoomAreaRectangle: (_: number) => void;
  onZoomAreaPolygon: (_: number) => void;
  onZoomMark: (_: number) => void;
  disabled?: boolean;
};

export const ObjectList = forwardRef<HTMLDivElement, Props>(
  ({ isOpen, onToggleList, onZoomMachine, onZoomAreaRectangle, onZoomAreaPolygon, onZoomMark, disabled }, ref) => {
    const objectList = useObjectList();

    return (
      <div ref={ref} className={disabled ? "hidden" : ""}>
        <ObjectListHeader
          isOpen={isOpen}
          onToggleList={onToggleList}
          target={objectList.target}
          onChangeTarget={objectList.setTarget}
          machineStatus={objectList.machineStatus}
          onFilterMachineStatus={objectList.setMachineStatus}
        />
        {/* 重機一覧 */}
        {isOpen && objectList.target === "machine" && (
          <MachineList filter={objectList.machineStatus} onZoomMachine={onZoomMachine} />
        )}
        {/* 立入禁止エリア・マーク一覧*/}
        {isOpen && objectList.target === "other" && (
          <OtherObjectList
            onZoomAreaRectangle={onZoomAreaRectangle}
            onZoomAreaPolygon={onZoomAreaPolygon}
            onZoomMark={onZoomMark}
          />
        )}
      </div>
    );
  }
);

ObjectList.displayName = "ObjectList";
